module.exports = "/images/death-of-loved-one-background.png?80b78682fd2bf95ad10626e2120fdaf5";